class MobileImageSwiper {
	constructor() {
		this.firstItem = document.querySelector('.product-grid .grid__item:first-of-type');
		this.allItems = document.querySelectorAll('.product-grid .grid__item .mobile-swipe');
		this.container = this.firstItem?.querySelector(".mobile-swipe") || null;
		this.sessionKey = "mobileSwipeHintDismissed";

		this.init();
	}

	init() {
		if (!this.container) return;

		if (this.isDismissedInSession()) return;

		this.container.classList.add("mobile-swipe--hint");

		this.addEventListeners();
	}

	isDismissedInSession() {
		try {
			return sessionStorage.getItem(this.sessionKey) === "1";
		} catch (e) {
			return false;
		}
	}

	markDismissedInSession() {
		try {
			sessionStorage.setItem(this.sessionKey, "1");
		} catch (e) {
		}
	}

	addEventListeners() {
		const cancel = () => {
			this.markDismissedInSession();
			this.cancelHintScroll();
		}

		this.allItems.forEach(el => {
			el.addEventListener("touchstart", cancel, {passive: true, once: true});
		});
	}

	cancelHintScroll() {
		this.container.classList.remove('mobile-swipe--hint');
	}

}

document.addEventListener("DOMContentLoaded", () => new MobileImageSwiper());
